import * as yup from 'yup';
import docs from './attachments';
import {
  acao,
  aceiteCienciaExclusao,
  consentimentoDadosSensiveis,
  cpfBeneficiario,
  medicos,
  nascimentoBeneficiario,
  nomeBeneficiario,
  nomeMaeBeneficiario,
  nomePaiBeneficiario,
  parentesco,
  plano,
  situacaoParentescoBeneficiario,
} from './utils/rulesByKey';

export const BeneficiarioRCMSchema = (planos = []) => {
  return yup.object({
    ...plano(planos.length > 1),
    ...nomeBeneficiario,
    ...cpfBeneficiario,
    ...nascimentoBeneficiario,
    ...nomeMaeBeneficiario,
    ...nomePaiBeneficiario,
    ...parentesco,
    ...medicos('medicoPerito', false, true),
    ...medicos('medicoAssistente', false, true),
    ...consentimentoDadosSensiveis(),
    ...aceiteCienciaExclusao,
    ...acao,
    ...situacaoParentescoBeneficiario,
    ...docs.BeneficiarioRCMDocs.rules,
  });
};

export const BeneficiarioRCMInitialValues = {
  plano: '',
  nomeBeneficiario: '',
  cpf: '',
  nascimento: '',
  nomeMaeBeneficiario: '',
  nomePaiBeneficiario: '',
  parentesco: '',
  medicoPerito: '',
  medicoAssistente: '',
  acao: '',
  situacaoParentesco: '',
  consentimentoDadosSensiveis: false,
  aceiteCienciaExclusao: false,

  ...docs.BeneficiarioRCMDocs.initialValues,
};

export const BeneficiarioRCMDocs = docs.BeneficiarioRCMDocs.docs;
